module.exports = __webpack_public_path__ + "img/woman.4fc1afe2.png";